import React from 'react';
import ImgComparisonNova from 'assets/img/premium/comparison-nova.jpg';
import ImgComparisonNovaSM from 'assets/img/premium/comparison-nova-sm.jpg';
import './FreePremium.css';
import { Link } from 'react-router-dom';

type Props = {
  isNova?: boolean;
  tier?: string;
};

const FreePremium: React.FC<Props> = ({isNova = true, tier = 'free'}) => {
  return (
    <>
      <h3 className="dashboard-profile-title"><span className="text-gradient text-gradient--premium">Chọn mua gói ELSA Premium phiên bản mới nhất</span> để truy cập đầy đủ tất cả tính năng và nâng trình tiếng Anh nhanh chóng!</h3>
      <div className="card-package">
        <div className="card-package__panel">
          <div className="card-package-header">
            <picture>
              <source srcSet={ImgComparisonNova} media="(min-width: 768px)" />
              <img src={ImgComparisonNovaSM} alt="Comparison" />
            </picture>
          </div>

          <div className="card-package-body">
            <h3 className="card-package-body__title">Trải nghiệm phiên bản ELSA mới nhất</h3>
            <p>Đối thoại trực tiếp với AI</p>
            <Link to='/elsa-premium' className="btn-primary">Đăng ký ngay</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default FreePremium;
